import { render, staticRenderFns } from "./HotelList.vue?vue&type=template&id=20967cc4&scoped=true"
import script from "./HotelList.vue?vue&type=script&lang=js"
export * from "./HotelList.vue?vue&type=script&lang=js"
import style0 from "./HotelList.vue?vue&type=style&index=0&id=20967cc4&prod&lang=scss&scoped=true"
import style1 from "./HotelList.vue?vue&type=style&index=1&id=20967cc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20967cc4",
  null
  
)

export default component.exports